<div class="visualizations-container">
  <nz-collapse nzAccordion nzBordered="false">
    <nz-collapse-panel
      nz-tooltip
      nzOverlayClassName="header-tooltip"
      nzTooltipTitle="See individual analyst forecasts vs. the consensus"
      nzHeader="Variation"
      [nzTooltipPlacement]="'left'"
      [nzShowArrow]="false"
      [nzActive]="getPanelProperty(PANEL_NAMES.variation, 'selected') !== ''"
      (nzActiveChange)="onPanelExpandCollapse(PANEL_NAMES.variation, $event)"
    >
      <span class="info-text">Only Columns Supported</span>
      <div class="sensitivity-slider">
        <span class="text">Sensitivity</span>
        <div class="slider">
          <span (click)="onMinMaxClick(0, -2, -1, -9)" class="text">
            MIN
          </span>
          <nz-slider
            [nzTipFormatter]="null"
            [nzMin]="0"
            [nzMax]="4"
            [ngModel]="
              (getPanelProperty(PANEL_NAMES.variation, 'slider') + 9) / 2
            "
            (ngModelChange)="onSliderChange(PANEL_NAMES.variation, $event)"
          >
          </nz-slider>
          <span (click)="onMinMaxClick(0, 2, -1, -9)" class="text">MAX</span>
        </div>
      </div>
    </nz-collapse-panel>
    <nz-collapse-panel
      nz-tooltip
      nzOverlayClassName="header-tooltip"
      nzTooltipTitle="See estimate revisions over time"
      nzHeader="Revisions"
      [nzTooltipPlacement]="'left'"
      [nzShowArrow]="false"
      [nzActive]="getPanelProperty(PANEL_NAMES.revisions, 'selected') !== ''"
      (nzActiveChange)="onPanelExpandCollapse(PANEL_NAMES.revisions, $event)"
    >
      <span class="info-text">Only Columns Supported</span>

      <nz-radio-group
        [(ngModel)]="getPanelProperty(PANEL_NAMES.revisions, null).value"
        (ngModelChange)="handleModelChanges()"
      >
        <label class="radio-sm" nz-radio nzValue="-6Month">-6Month</label>
        <label class="radio-sm" nz-radio nzValue="-3Month">-3Month</label>
        <label class="radio-sm" nz-radio nzValue="-1Month">-1Month</label>
        <label class="radio-sm" nz-radio nzValue="-1Week">-1Week</label>
        <label class="radio-sm" nz-radio nzValue="PreQ">PreQ</label>
      </nz-radio-group>
      <div class="sensitivity-slider">
        <span class="text">Sensitivity</span>
        <div class="slider">
          <span (click)="onMinMaxClick(1, -2, -1, -9)" class="text">MIN</span>
          <nz-slider
            [nzTipFormatter]="null"
            [nzMin]="0"
            [nzMax]="4"
            [ngModel]="
              (getPanelProperty(PANEL_NAMES.revisions, 'slider') + 9) / 2
            "
            (ngModelChange)="onSliderChange(PANEL_NAMES.revisions, $event)"
          >
          </nz-slider>
          <span (click)="onMinMaxClick(1, 2, -1, -9)" class="text">MAX</span>
        </div>
      </div>
    </nz-collapse-panel>
    <nz-collapse-panel
      nz-tooltip
      nzOverlayClassName="header-tooltip"
      nzTooltipTitle="Surprise Analysis"
      nzHeader="Surprise"
      [nzTooltipPlacement]="'left'"
      [nzShowArrow]="false"
      [nzActive]="getPanelProperty(PANEL_NAMES.surprise, 'selected') !== ''"
      (nzActiveChange)="onPanelExpandCollapse(PANEL_NAMES.surprise, $event)"
    >
      <div class="sensitivity-slider">
        <span class="text">Sensitivity</span>
        <div class="slider">
          <span (click)="onMinMaxClick(3, -1, 5, 1)" class="text">MIN</span>
          <nz-slider
            [nzTipFormatter]="null"
            [nzMin]="1"
            [nzMax]="5"
            [ngModel]="getPanelProperty(PANEL_NAMES.surprise, 'slider')"
            (ngModelChange)="onSliderChange(PANEL_NAMES.surprise, $event)"
          >
          </nz-slider>
          <span (click)="onMinMaxClick(3, 1, 5, 1)" class="text">MAX</span>
        </div>
      </div>
    </nz-collapse-panel>
    <nz-collapse-panel
      nz-tooltip
      nzOverlayClassName="header-tooltip"
      nzTooltipTitle="See the highest and lowest broker estimate for each line item"
      nzHeader="High / Low"
      [nzTooltipPlacement]="'left'"
      [nzShowArrow]="false"
      [nzActive]="getPanelProperty(PANEL_NAMES.highLow, 'selected') === true"
      (nzActiveChange)="onPanelExpandCollapse(PANEL_NAMES.highLow, $event)"
    >
      <div class="checkbox-sm">
        <label
          class="text"
          nz-checkbox
          (ngModelChange)="onHighLowCheckChange(0, $event)"
          [ngModel]="
            getPanelProperty(PANEL_NAMES.highLow, 'values')[0].selected
          "
          >High
        </label>
      </div>

      <div class="checkbox-sm">
        <label
          class="text"
          nz-checkbox
          (ngModelChange)="onHighLowCheckChange(1, $event)"
          [ngModel]="
            getPanelProperty(PANEL_NAMES.highLow, 'values')[1].selected
          "
          >Low
        </label>
      </div>

      <div class="horizontal-divider"></div>

      <nz-radio-group
        [(ngModel)]="getPanelProperty(PANEL_NAMES.highLow, null).high_low_src"
        class="toggle-all-or-entitled-sources"
        (ngModelChange)="handleModelChanges()"
      >
        <label class="text" nz-radio [nzValue]="'all'">All Sources</label>
        <label class="text" nz-radio [nzValue]="'entitled'"
          >Entitled Sources</label
        >
      </nz-radio-group>
    </nz-collapse-panel>
  </nz-collapse>
</div>

<div class="actions">
  <button
    [disabled]="actionsDisabled"
    nz-button
    nzType="default"
    nzSize="small"
    (click)="handleCancel()"
  >
    Cancel
  </button>
  <button
    id="options-refresh-buttons-apply-Analysis"
    [disabled]="actionsDisabled"
    nz-button
    nzType="primary"
    nzSize="small"
    (click)="handleApply($event)"
  >
    Apply
  </button>
</div>
